import { render, staticRenderFns } from "./transToPurchaseOrder.vue?vue&type=template&id=6a13b181&scoped=true&"
import script from "./transToPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./transToPurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./transToPurchaseOrder.vue?vue&type=style&index=0&id=6a13b181&lang=less&scoped=true&"
import style1 from "./transToPurchaseOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13b181",
  null
  
)

component.options.__file = "transToPurchaseOrder.vue"
export default component.exports